import React from 'react';
import { Box } from '@mui/material';
import { GestionNDDWidget, GestionNDDWidgetType } from '../../molecules';

export type GestionNDDListProps = {
    items?: Array<GestionNDDWidgetType>;
};

export const GestionNDDList: React.FunctionComponent<GestionNDDListProps> = function (
    props: GestionNDDListProps,
) {
    const { items } = props;
    return (
        <Box>
            {items
                ? items.map((itemProps: GestionNDDWidgetType, index) => (
                      <GestionNDDWidget
                          key={`gestionNDD-${itemProps.gestionNDD.personneMorale.identite.nomsDeDomaine.nomDomaine}`}
                          {...itemProps}
                          index={index}
                      />
                  ))
                : null}
        </Box>
    );
};
